import { CaseStudy } from "@/components/CaseStudyCard";
import newsPizzeriaImg from "@/assets/news-pizzeria.jpg";
import newsAutomationImg from "@/assets/news-automation.jpg";
import newsWhatsappImg from "@/assets/news-whatsapp-ai.jpg";

export const caseStudies: CaseStudy[] = [
  {
    id: 1,
    businessName: "Pizzería Don Pepe",
    industry: "Hostelería",
    image: newsPizzeriaImg,
    before: {
      title: "Antes",
      problems: [
        "5 horas al día atendiendo llamadas",
        "Pedidos perdidos fuera de horario",
        "Errores en anotación manual",
        "Estrés constante del personal"
      ]
    },
    after: {
      title: "Después",
      solutions: [
        "Asistente de voz IA 24/7",
        "0 pedidos perdidos",
        "Pedidos directos al sistema",
        "Equipo enfocado en cocina"
      ]
    },
    roi: {
      metric: "Inversión recuperada en",
      value: "2 meses",
      timeframe: "ROI 500%"
    },
    testimonial: {
      quote: "Recuperé mis tardes. Literalmente. El asistente atiende mejor que yo y nunca se equivoca.",
      author: "María González",
      role: "Propietaria, Pizzería Don Pepe"
    }
  },
  {
    id: 2,
    businessName: "Consultoría Empresarial Sigma",
    industry: "Consultoría",
    image: newsAutomationImg,
    before: {
      title: "Antes",
      problems: [
        "10 horas semanales en propuestas",
        "Plantillas desactualizadas",
        "Inconsistencia en presupuestos",
        "Clientes esperando días"
      ]
    },
    after: {
      title: "Después",
      solutions: [
        "Propuestas generadas en 5 min",
        "Contenido personalizado por IA",
        "Formato profesional consistente",
        "Respuesta inmediata a clientes"
      ]
    },
    roi: {
      metric: "Tiempo ahorrado",
      value: "40h/mes",
      timeframe: "Ahorro 1.600€/mes"
    },
    testimonial: {
      quote: "Antes tardaba medio día en hacer una propuesta. Ahora la IA me la prepara mientras desayuno.",
      author: "Carlos Ruiz",
      role: "CEO, Consultoría Sigma"
    }
  },
  {
    id: 3,
    businessName: "E-commerce NaturalFit",
    industry: "E-commerce",
    image: newsWhatsappImg,
    before: {
      title: "Antes",
      problems: [
        "200+ consultas diarias sin responder",
        "Soporte solo en horario laboral",
        "Clientes abandonando carritos",
        "Equipo saturado"
      ]
    },
    after: {
      title: "Después",
      solutions: [
        "Chatbot IA en WhatsApp 24/7",
        "Respuestas instantáneas",
        "Conversión de abandono +35%",
        "Equipo enfocado en casos complejos"
      ]
    },
    roi: {
      metric: "Incremento en ventas",
      value: "+45%",
      timeframe: "3 primeros meses"
    },
    testimonial: {
      quote: "Los clientes están encantados. Respuestas al instante, incluso a las 3 AM. Y nuestras ventas se dispararon.",
      author: "Laura Martín",
      role: "Directora, NaturalFit"
    }
  },
  {
    id: 4,
    businessName: "Clínica Dental Sonrisas",
    industry: "Salud",
    image: newsAutomationImg,
    before: {
      title: "Antes",
      problems: [
        "Recepcionista colapsada",
        "Pacientes esperando al teléfono",
        "Citas mal agendadas",
        "Recordatorios manuales"
      ]
    },
    after: {
      title: "Después",
      solutions: [
        "Sistema de citas por voz IA",
        "Confirmaciones automáticas",
        "0 conflictos de horario",
        "Recordatorios inteligentes"
      ]
    },
    roi: {
      metric: "Reducción de no-shows",
      value: "-70%",
      timeframe: "Impacto inmediato"
    },
    testimonial: {
      quote: "La recepcionista ahora puede atender mejor a los pacientes presenciales. El sistema de IA nunca se satura.",
      author: "Dr. Javier Sánchez",
      role: "Director, Clínica Sonrisas"
    }
  }
];
